/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.AccountPermissionsResponse, (requestParams: vp.AccountPermissionsRequest) => void, () => void];

function useFetchAccountPermissions({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.AccountPermissionsRequest>();
  const [response, setResponse] = useState<vp.AccountPermissionsResponse>({
    ErrorMessage: '',
    Success: false,
    Username: '',
    Permissions: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.AccountPermissionsRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchAccountPermissions(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.AccountPermissionsRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        Username: '',
        Permissions: {},
      });
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchAccountPermissions);
